import { render, staticRenderFns } from "./selectCampus.vue?vue&type=template&id=7aec5bef&scoped=true"
import script from "./selectCampus.vue?vue&type=script&lang=js"
export * from "./selectCampus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aec5bef",
  null
  
)

export default component.exports